import StickyPageHeader from '../components/common/StickyPageHeader';
import RateClassList from '../components/lists/RateClassList';
import {
  useDefaultClasses,
  useDefaultVehicles,
  useVehicleDefaultClasses,
} from '../hooks/apiHooks';
import Layout from '../layout';

const AdminRateClassesPage = ({ routes }) => {
  const { defaultClasses } = useDefaultClasses();
  const { defaultVehicles } = useDefaultVehicles();
  const { vehicleDefaultClasses } = useVehicleDefaultClasses();

  return (
    <>
      <StickyPageHeader isAdmin title="Settings / API Rate Classes" />
      <Layout
        showCarriersNavigation
        disableLoading={false}
        menuIndex={0}
        routes={routes}
      >
        <RateClassList
          defaultClasses={defaultClasses}
          id="vehicle-default-class"
          vehicleDefaultClasses={vehicleDefaultClasses}
          vehicles={defaultVehicles}
        />
      </Layout>
    </>
  );
};

export default AdminRateClassesPage;
